import { inject, Injectable, signal } from '@angular/core';
import { ItemScanRepository, ScannedProduct } from '../repositories/item-scan.repository';

@Injectable()
export class ItemScanService {
  readonly #itemScanRepository = inject(ItemScanRepository);
  readonly loading = signal(false);

  async resolveProduct(
    labelType: string,
    data: string
  ): Promise<ScannedProduct | null> {
    this.loading.set(true);
    try {
      return await this.#itemScanRepository.resolve(labelType, data);
    } finally {
      this.loading.set(false);
    }
  }
}
